import { render, staticRenderFns } from "./WeTextTooltip.vue?vue&type=template&id=55febbdb&"
import script from "./WeTextTooltip.vue?vue&type=script&lang=js&"
export * from "./WeTextTooltip.vue?vue&type=script&lang=js&"
import style0 from "./WeTextTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
